import { AppEntities } from "../../../../config/entities";
import { CatalogListView } from "../../../Shared/CatalogListView";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { CatalogListViewDefaultToolbarButtons } from "../../../Shared/ListViews/CatalogListViewDefaultToolbarButtons";
import { CatalogListViewToolbar } from "../../../Shared/ListViews/CatalogListViewToolbar";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const VatList = () => {
  const fields: IListViewField[] = [{ title: "Name", fieldName: "name" }];

  return (
    <>
      <CatalogListView fields={fields} entity={AppEntities.VatTypes}>
        <CatalogListViewToolbar>
          <CatalogListViewDefaultToolbarButtons />
        </CatalogListViewToolbar>
      </CatalogListView>{" "}
    </>
  );
};

export default VatList;
